import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import BASE_URL from '../../config/apiConfig';

const GitHubCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    if (!code) {
      toast.error('Missing authorization code from GitHub');
      return navigate('/myconnections');
    }

    const handleCallback = async () => {
      try {
        // Extract conn_id from state if available
        let conn_id = null;
        if (state) {
          try {
            // State might be JSON string or base64 encoded
            let stateData;
            try {
              // Try parsing as JSON first
              stateData = JSON.parse(state);
            } catch (e) {
              // If that fails, try base64 decoding
              try {
                const decoded = atob(state);
                stateData = JSON.parse(decoded);
              } catch (e2) {
                // If both fail, try URL decoding then JSON parsing
                const decoded = decodeURIComponent(state);
                stateData = JSON.parse(decoded);
              }
            }
            conn_id = stateData.conn_id;
            console.log('Extracted conn_id from state:', conn_id);
          } catch (e) {
            // State might not be JSON, ignore
            console.warn('Failed to parse state:', e);
          }
        }

        // Use backend API URL directly
        const backendApiUrl = process.env.REACT_APP_API_URL || BASE_URL;
        const callbackUrl = `${backendApiUrl}/api/v1/oauth/github/callback`;

        console.log('Calling GitHub OAuth callback:', callbackUrl);
        console.log('Request payload:', { code, conn_id });

        const res = await axios.post(
          callbackUrl,
          { code, conn_id },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (res.data) {
          toast.success('GitHub connected successfully!');
          navigate('/myconnections');
        } else {
          toast.warn('GitHub connected, but no response data found.');
          navigate('/myconnections');
        }
      } catch (error) {
        console.error('GitHub callback error:', error);
        const errorMsg = error.response?.data?.detail || error.response?.data?.message || error.message || 'GitHub connection failed';
        toast.error(`GitHub connection failed: ${errorMsg}`);
        navigate('/myconnections');
      }
    };

    handleCallback();
  }, [navigate]);

  return <div>Connecting your GitHub account...</div>;
};

export default GitHubCallback;

